import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation } from '@tanstack/react-query';
import { RejectBillValidationSchema } from '../schemas/rejectBill.schema';

interface UseRejectBillingBillProps {
  billId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: ErrorResponse) => void;
}

export const useRejectBillingBill = ({ billId, onSuccess, onError }: UseRejectBillingBillProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['rejectBillingBill', billId],
    mutationFn: (data: RejectBillValidationSchema) => privateAxios.put(`/billing/bills/${billId}/reject`, data),
    onSuccess,
    onError,
  });
};
